<div class="flex grid-cols-2 flex-col gap-4 md:grid md:justify-between">
  <h2
    class="text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
  >
    Orders
  </h2>
</div>

<!-- Cards -->
<div class="mt-[0.94rem] grid gap-6 md:grid-cols-2 lg:grid-cols-4"
*appHasPermission="'order_meta_data'">
  <!-- Investment Orders -->
  <div
    class="card__wrapper flex flex-col gap-2 rounded-lg border border-solid border-mango-gray200 bg-mango-paleBlue p-6"
  >
    <p class="text-sm font-medium leading-5 text-mango-gray500">
      Investment Orders
    </p>
    <p
      class="text-4xl font-extrabold leading-[2.75rem] tracking-[-0.045rem] text-mango-gray900"
    >
      {{ totalCount$ | async | number }}
    </p>
  </div>

  <!-- Liquidate investment -->
  <div
    class="card__wrapper flex flex-col gap-2 rounded-lg border border-solid border-mango-gray200 bg-mango-lightOrange p-6"
  >
    <p class="text-sm font-medium leading-5 text-mango-gray500">
      Liquidate investment
    </p>
    <p
      class="text-4xl font-extrabold leading-[2.75rem] tracking-[-0.045rem] text-mango-gray900"
    >
      {{ totalSales | number }}
    </p>
  </div>

  <!-- Approved Orders -->
  <div
    class="card__wrapper flex flex-col gap-2 rounded-lg border border-solid bg-mango-paleGreen p-6"
  >
    <p class="text-sm font-medium leading-5 text-mango-gray500">
      Approved Orders
    </p>
    <p
      class="text-4xl font-extrabold leading-[2.75rem] tracking-[-0.045rem] text-mango-gray900"
    >
      {{ totalCount && totalRejected ? totalCount - totalRejected : 0 }}
    </p>
  </div>

  <!-- Rejected Orders -->
  <div
    class="card__wrapper flex flex-col gap-2 rounded-lg border border-solid bg-mango-shellRed p-6"
  >
    <p class="text-sm font-medium leading-5 text-mango-gray500">
      Rejected Orders
    </p>
    <p
      class="text-4xl font-extrabold leading-[2.75rem] tracking-[-0.045rem] text-mango-gray900"
    >
      {{ totalRejected }}
    </p>
  </div>

  <!-- Initiated Orders -->
  <div
    class="card__wrapper flex flex-col gap-2 rounded-lg border border-solid border-mango-gray200 bg-mango-paleGray p-6"
  >
    <p class="text-sm font-medium leading-5 text-mango-gray500">
      Initiated Orders
    </p>
    <p
      class="text-4xl font-extrabold leading-[2.75rem] tracking-[-0.045rem] text-mango-gray900"
    >
      {{ totalInitiated }}
    </p>
  </div>

  <!-- Orders in Process -->
  <div
    class="card__wrapper flex flex-col gap-2 rounded-lg border border-solid border-mango-gray200 bg-mango/40 p-6"
  >
    <p class="text-sm font-medium leading-5 text-mango-gray500">
      Orders in Process
    </p>
    <p
      class="text-4xl font-extrabold leading-[2.75rem] tracking-[-0.045rem] text-mango-gray900"
    >
      {{ totalProcess }}
    </p>
  </div>
</div>

<div class="tab__wrapper mb-6 mt-[0.94rem]">
      <!-- Tabs for desktop -->
      <div class="hidden w-fit rounded-lg bg-white sm:block">
        <nav class="flex w-fit space-x-4 p-[0.31rem]" aria-label="Tabs">
          <a
            *appHasPermission="'get_all_order'"
            [routerLink]="customerOrdersUrl"
            routerLinkActive="bg-mango-lightOrange text-mango"
            class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
            ><span>Customer Orders</span></a
          >
          <a
            *appHasPermission="['get_all_order', 'can_get_all_mfd_trx_request']"
            [routerLink]="orderApprovalUrl"
            routerLinkActive="bg-mango-lightOrange text-mango"
            class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
            ><span>Order Approvals</span></a
          >
        </nav>
      </div>
    </div>
<router-outlet></router-outlet>